// removed by extract-text-webpack-plugin
module.exports = {"block":"ButtonDefault__block-2yvAJ","isFullWidth":"ButtonDefault__isFullWidth-hG5TD"};